<div class="view-enter-animation">
  <section
    class="mobi-ui-section-minor mobi-ui-section-illustration-wrapper-minor is-left !mx-0 mobi-ui-padding-y-xxxl"
    [class.mobi-ui-ink-default]="light()"
    [class.mobi-ui-ink-black]="!light()"
  >
    <div class="mobi-ui-grid is-centered">
      <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
        @if (illustration()) {
          <mobi-ui-illustration-major
            class="w-auto !max-h-[calc(32*(var(--mobi-ui-scale-unit)))] sm:!max-h-[calc(45*(var(--mobi-ui-scale-unit)))] mobi-ui-section-illustration-minor is-left xl:!left-[calc(4*(var(--mobi-ui-scale-unit))+12.5%)]"
            [illustration]="illustration()!"
            [fullHeight]="true"
            [lazy]="false"
          ></mobi-ui-illustration-major>
        }

        <div class="mobi-ui-ink-default">
          <ng-container [ngTemplateOutlet]="content()" />
        </div>
      </div>
    </div>
  </section>
</div>
